import OtpHistory from '@/modules/integrations/types/otp/OtpHistory.vue'
import OtpOverview from '@/modules/integrations/types/otp/OtpOverview.vue'
import OtpSettings from '@/modules/integrations/types/otp/OtpSettings.vue'

export default Object.freeze({
  type: 'otp',
  title: 'Integrations_Otp',
  category: 'Integrations_Otp_Category',
  description: 'Integrations_Otp_Description',
  image: require('@/img/integrations/otp.png'),
  requiresAdmin: false,
  components: {
    overview: OtpOverview,
    settings: OtpSettings,
    history: OtpHistory
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/one-time-password'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/otp/index.js